import type { DeleteEvent, PageSettings, SaveEvent } from "@syncfusion/react-grid";
import type React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export abstract class DataSource<T extends {id: string}> {

    protected navigate = useNavigate()
    protected url: string;
    public data: T[];
    public setData: React.Dispatch<T[]>;
    public setPageSettings: React.Dispatch<PageSettings>;
    public pageSettings: PageSettings;

    constructor(
        url: string) {
            
            const [data, setData] = useState<T[]>([]);
            const [pageSettings, setPageSettings] = useState<PageSettings>({ enabled: true, pageSize: 8, pageCount: 4, totalRecordsCount: 0 });
            this.url = url;
            this.data = data;
            this.setData = setData;
            this.setPageSettings = setPageSettings;
            this.pageSettings = pageSettings;

            
            

    }

    public async get(){
        let response = await fetch(this.url);
        this.handleResponse(response);
        let result = await response.json();
        this.setData(result.items);
        this.setPageSettings({... this.pageSettings, totalRecordsCount: result.count || 0 });
    }

    private handleResponse(response: Response){
        if(response.status == 401){
            this.navigate("/Login")
        }
    }

    public  dataChangeStart = async ( event: SaveEvent<T> | DeleteEvent<T>) => {
            event.cancel = true;
            let user: T = event.data as T;
            if(event.action == "Edit"){
               user = await this.put(user);
            }else if(event.action == "Add"){
                user = await this.post(user);
            }else if(event.action == "Delete"){
                let users = event.data as T[]
                await this.delete(users);
            }
        };

    public async put(item: T){
         let response = await fetch(`${this.url}/${item.id}`, {
                    body: JSON.stringify(item),
                    method: 'PUT',
                    headers: {
                        "Content-Type": 'application/json'
                    }
        });
        this.handleResponse(response);
        let result: T = await response.json();
        let data = this.data.map(e => e.id != result.id ? e : result);
        this.setData(data);
        return result;
    }

    public async post(item: T){
         let response = await fetch(`${this.url}`, {
                    body: JSON.stringify(item),
                    method: 'POST',
                    headers: {
                        "Content-Type": 'application/json'
                    }
        });
        this.handleResponse(response);
        let result: T = await response.json();
        let data = this.data.map(e => e);
        data.unshift(result);
        this.setPageSettings({...this.pageSettings, totalRecordsCount: (this.pageSettings?.totalRecordsCount || 0) + 1});
        this.setData(data);
        return result;
    }
    public async delete(items: T[]){
        let data = this.data.map(e => e)
        for(let item of items){
         let response = await fetch(`${this.url}/${item.id}`, {
                    method: 'DELETE',
                    headers: {
                        "Content-Type": 'application/json'
                    }
        });
        this.handleResponse(response);
        let result: T = await response.json();
        data = data.filter(e => e.id != result.id);
        }
        
        this.setPageSettings({...this.pageSettings, totalRecordsCount: (this.pageSettings?.totalRecordsCount || 0) - 1});
        this.setData(data);
    }

}